import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { getStorageItem } from "../utils/sessionStorage";
import { toast } from "react-toastify";
import Card from "./Card";
import "./marketplace.scss";
import AddressPage from "./addressPage/AddressPage";
import { CartContext } from "../context/CartContext";
// import OrderModal from "../marketplace/OrderModal";

// User Information
const userId = getStorageItem("user_id");

// Access Token
const accessToken = getStorageItem("token");

const MarketPlace = () => {
  const navigate = useNavigate();
  const Heading = ({ name, redirect }) => {
    return (
      <div className="marketplace__section--header">
        <h3 className="marketplace__section__title">{name}</h3>
        <div
          className="marketplace__section__see-more"
          onClick={() => {
            navigate(redirect);
          }}
        >
          See more
        </div>
      </div>
    );
  };
  const [allProducts, setAllProducts] = useState([]);
  const [popularProducts, setPopularProducts] = useState([]);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [newProducts, setNewProducts] = useState([]);
  const [adminProducts, setAdminProducts] = useState([]);
  const [firstProduct, setFirstProduct] = useState(null);
  const [secondProduct, setSecondProduct] = useState(null);
  const [thirdProduct, setThirdProduct] = useState(null);
  const [fourthProduct, setFourthProduct] = useState(null);
  const [fifthProduct, setFifthProduct] = useState(null);
  const [sixthProduct, setSixthProduct] = useState(null);
  const [menu, setMenu] = useState(true);
  const [cart, setCart] = useContext(CartContext);
  const categories = [
    {
      name: "Sporting Goods",
      image: "/svg/sportingGoods.svg",
    },
    {
      name: "Merchandise",
      image: "/svg/merchandise.svg",
    },
    {
      name: "Consumer Electronics",
      image: "/svg/consumerElectronics.svg",
    },
    {
      name: "Health Supplements",
      image: "/svg/healthSuppliments.svg",
    },
    {
      name: "Lifestyles",
      image: "/svg/lifestyle.svg",
    },
    {
      name: "Miscellaneous",
      image: "/svg/miscellaneous.svg",
    },
  ];

  // Function to get products
  async function fetchProducts() {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod + "/marketplace/product/getAllProducts",
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const products = await response.json();
      setAllProducts(products);
    } catch (err) {
      console.log(err);
    }
  }

  // Function to get new products
  async function fetchNewProducts() {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
          `/marketplace/product/getNewProducts?limit=20`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const { newProducts, count } = await response.json();
      setNewProducts(newProducts);
    } catch (err) {
      console.log(err);
    }
  }

  // Function to get popular products
  async function fetchPopularProducts() {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
          `/marketplace/product/getPopularProducts?limit=20`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const { popularProducts, count } = await response.json();
      setPopularProducts(popularProducts);
    } catch (err) {
      console.log(err);
    }
  }

  // Function to get trending products
  async function fetchTrendingProducts() {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
          `/marketplace/product/getTrendingProducts?limit=20`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const { trendingProducts, count } = await response.json();
      setTrendingProducts(trendingProducts);
    } catch (err) {
      console.log(err);
    }
  }

  // Function to like a product
  async function likeProduct(productId) {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
          `/marketplace/product/${productId}/like/${userId}`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
    } catch (err) {
      console.log(err);
    }
  }

  // Function to dislike a product
  async function unlikeProduct(productId) {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
          `/marketplace/product/${productId}/like/${userId}`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
    } catch (err) {
      console.log(err);
    }
  }

  // function to get admin priority products
  async function fetchAdminPriorityProducts() {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
          `/marketplace/product/adminPriorityProducts`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const adminPriorityProducts = await response.json();
      // set default values for each product state variable
      setFirstProduct(
        adminPriorityProducts.find(
          (product) => product.productPriority === 1
        ) || null
      );
      setSecondProduct(
        adminPriorityProducts.find(
          (product) => product.productPriority === 2
        ) || null
      );
      setThirdProduct(
        adminPriorityProducts.find(
          (product) => product.productPriority === 3
        ) || null
      );
      setFourthProduct(
        adminPriorityProducts.find(
          (product) => product.productPriority === 4
        ) || null
      );
      setFifthProduct(
        adminPriorityProducts.find(
          (product) => product.productPriority === 5
        ) || null
      );
      setSixthProduct(
        adminPriorityProducts.find(
          (product) => product.productPriority === 6
        ) || null
      );
      setAdminProducts(adminPriorityProducts);
    } catch (err) {
      console.log(err);
    }
  }

  // Call the fetchProducts function within the useEffect hook
  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    fetchNewProducts();
  }, []);

  useEffect(() => {
    fetchPopularProducts();
  }, []);

  useEffect(() => {
    fetchTrendingProducts();
  }, []);

  useEffect(() => {
    fetchAdminPriorityProducts();
  }, []);
  return (
    <div>
      <Helmet>
        <title>Champhunt | MarketPlace</title>
      </Helmet>
      <div className="main__wrapper--index">
        {/* Banner */}
        <div className="marketplace__banner">
          <div className="banner__products">
            {firstProduct ? (
              <div
                className={`product__item item${firstProduct?.productPriority}`}
                onClick={() => {
                  navigate(
                    `/marketplace/single/${firstProduct?.productId?._id}`
                  );
                }}
              >
                {firstProduct?.productId?.discount !== 0 && (
                  <div className="product__item_discount">
                    -
                    {Math.round(
                      firstProduct?.productId?.discount /
                        firstProduct?.productId?.runs
                    ) / 100}
                    %
                  </div>
                )}
                <img
                  src={firstProduct?.productId?.images[0]}
                  alt={firstProduct?.productId?.title}
                  className="product__item-productImage"
                />
                <div className="product__item_name">
                  {firstProduct?.productId?.title}{" "}
                </div>
              </div>
            ) : (
              <div className={`product__item item1`}></div>
            )}
            {secondProduct ? (
              <div
                className={`product__item item${secondProduct?.productPriority}`}
                onClick={() => {
                  navigate(
                    `/marketplace/single/${secondProduct?.productId?._id}`
                  );
                }}
              >
                {secondProduct?.productId?.discount !== 0 && (
                  <div className="product__item_discount">
                    -{secondProduct?.productId?.discount}%
                  </div>
                )}
                <img
                  src={secondProduct?.productId?.images[0]}
                  alt={secondProduct?.productId?.title}
                  className="product__item-productImage"
                />
                <div className="product__item_name">
                  {secondProduct?.productId?.title}{" "}
                </div>
              </div>
            ) : (
              <div className={`product__item item2`}></div>
            )}
            {thirdProduct ? (
              <div
                className={`product__item item${thirdProduct?.productPriority}`}
                onClick={() => {
                  navigate(
                    `/marketplace/single/${thirdProduct?.productId?._id}`
                  );
                }}
              >
                {thirdProduct?.productId?.discount !== 0 && (
                  <div className="product__item_discount">
                    -{thirdProduct?.productId?.discount}%
                  </div>
                )}
                <img
                  src={thirdProduct?.productId?.images[0]}
                  alt={thirdProduct?.productId?.title}
                  className="product__item-productImage"
                />
                <div className="product__item_name">
                  {thirdProduct?.productId?.title}{" "}
                </div>
              </div>
            ) : (
              <div className={`product__item item3`}></div>
            )}
            {fourthProduct ? (
              <div
                className={`product__item item${fourthProduct?.productPriority}`}
                onClick={() => {
                  navigate(
                    `/marketplace/single/${fourthProduct?.productId?._id}`
                  );
                }}
              >
                {fourthProduct?.productId?.discount !== 0 && (
                  <div className="product__item_discount">
                    -{fourthProduct?.productId?.discount}%
                  </div>
                )}
                <img
                  src={fourthProduct?.productId?.images[0]}
                  alt={fourthProduct?.productId?.title}
                  className="product__item-productImage"
                />
                <div className="product__item_name">
                  {fourthProduct?.productId?.title}{" "}
                </div>
              </div>
            ) : (
              <div className={`product__item item4`}></div>
            )}
            {fifthProduct ? (
              <div
                className={`product__item item${fifthProduct?.productPriority}`}
                onClick={() => {
                  navigate(
                    `/marketplace/single/${fifthProduct?.productId?._id}`
                  );
                }}
              >
                {fifthProduct?.productId?.discount !== 0 && (
                  <div className="product__item_discount">
                    -{fifthProduct?.productId?.discount}%
                  </div>
                )}
                <img
                  src={fifthProduct?.productId?.images[0]}
                  alt={fifthProduct?.productId?.title}
                  className="product__item-productImage"
                />
                <div className="product__item_name">
                  {fifthProduct?.productId?.title}{" "}
                </div>
              </div>
            ) : (
              <div className={`product__item item5`}></div>
            )}
          </div>
        </div>
        {/* Categories */}
        <div className="products__categories">
          <div className="category__options">
            <h3 className="category__title">Category</h3>
            <h3 className="category__see-more">See more</h3>
          </div>
          <div className="category__grid">
            {categories.map((category, index) => {
              return (
                <div key={index} className="category__products">
                  <div
                    className="category__box"
                    onClick={() => {
                      navigate(`/marketplace/category/${category.name}`);
                    }}
                  >
                    <img
                      src={
                        category.image ||
                        "https://e7.pngegg.com/pngimages/483/759/png-clipart-nike-air-max-nike-free-air-force-shoe-nike-white-outdoor-shoe.png"
                      }
                      alt="category"
                      className="category__image"
                    />
                  </div>
                  <h4 className="category__name">{category.name}</h4>
                </div>
              );
            })}
          </div>
        </div>
        {/* Popular */}
        {popularProducts.length > 0 && (
          <div className="products__popular">
            <Heading name="Popular" redirect="/marketplace/popular" />
            <div className="products__list">
              {popularProducts?.map((product, index) => {
                return <Card key={index} product={product} index={index} />;
              })}
            </div>
          </div>
        )}
        {/* BannerSingle */}
        {sixthProduct && (
          <div className="banner__single">
            <div
              className="banner__product"
              onClick={() => {
                navigate(`/marketplace/single/${sixthProduct?._id}`);
              }}
            >
              {sixthProduct?.productId?.discount > 0 && (
                <div className="banner__discount">
                  -
                  {Math.round(
                    (sixthProduct?.productId?.discount /
                      sixthProduct?.productId?.price) *
                      100
                  )}
                  %
                </div>
              )}
              {sixthProduct?.productId?.images &&
                sixthProduct?.productId?.images[0] && (
                  <img
                    src={sixthProduct?.productId?.images[0]}
                    alt="banner-product"
                    className="banner__product"
                  />
                )}
              <div className="banner__description">
                {sixthProduct?.productId?.title}
              </div>
            </div>
          </div>
        )}
        {/* Trending */}
        {trendingProducts.length > 0 && (
          <div className="products__trending">
            <Heading name="Trending" redirect="/marketplace/trending" />
            <div className="products__list">
              {trendingProducts.map((product, index) => {
                return <Card product={product} index={index} />;
              })}
            </div>
          </div>
        )}
        {/* New */}
        {newProducts.length > 0 && (
          <div className="products__new">
            <Heading name="New" redirect="/marketplace/new" />
            <div className="products__list">
              {newProducts.map((product, index) => {
                return <Card key={index} product={product} index={index} />;
              })}
            </div>
          </div>
        )}
        {/* Icons */}
        <div className="icon__wrapper">
          <div className="icon__box">
            {menu && (
              <>
                <div
                  className="icon"
                  onClick={() => {
                    navigate("/marketplace/sell");
                  }}
                >
                  <img src="/marketplace/sell.svg" alt="sell" />
                  <h4 className="icon__text">Sell</h4>
                </div>
                <div
                  className="icon"
                  onClick={() => {
                    navigate("/marketplace/list");
                  }}
                >
                  <img src="/marketplace/list.svg" alt="list" />
                  <h4 className="icon__text">List</h4>
                </div>
                <div
                  className="icon"
                  onClick={() => {
                    navigate(`/marketplace/order_status/${userId}`);
                  }}
                >
                  <img src="/marketplace/history.svg" alt="history" />
                  <h4 className="icon__text">Order</h4>
                </div>
                <div
                  className="icon"
                  onClick={() => {
                    navigate("/marketplace/wishlist");
                  }}
                >
                  <img src="/marketplace/wish-list.svg" alt="wish-list" />
                  <h4 className="icon__text">Wish List</h4>
                </div>
                <div
                  className="icon"
                  onClick={() => {
                    navigate("/marketplace/cart");
                  }}
                >
                  {cart?.length > 0 && (
                    <div className="cart-items-notify">{cart?.length}</div>
                  )}
                  <img src="/marketplace/cart.svg" alt="wish-list" />
                  <h4 className="icon__text">Cart</h4>
                </div>
              </>
            )}
            <div
              className="icon"
              // onClick={() => {
              //   setMenu(!menu);
              // }}
            >
              <img src="/marketplace/next.svg" alt="next" />
              <h4 className="icon__text">&nbsp;Menu</h4>
            </div>
          </div>
        </div>

        {/* <AddressPage /> */}
        {/* <OrderModal /> */}
      </div>
    </div>
  );
};

export default MarketPlace;
